<p-toast position="top-center"></p-toast>
<div class="flex flex-1 flex-column px-6" *ngIf="processing">
  <div class="flex justify-content-center mb-2">
    <img
      src="assets/images/logo.png"
      alt="Logo"
      style="max-width: 100%; max-height: 200px"
    />
  </div>
  <div class="flex justify-content-center" style="height: 140px">
    <ng-lottie [options]="options"></ng-lottie>
  </div>
  <div class="flex justify-content-center">
    {{ "AUTH.RECOVERING" | translate }}
  </div>
</div>
<div class="flex flex-1 flex-column px-6" *ngIf="!processing">
  <div class="flex flex-1 flex-column">
    <div class="flex justify-content-center flex-1">
      <h3>{{ "AUTH.PASSWORD-RECOVER" | translate }}</h3>
    </div>
    <form
      #dataForm="ngForm"
      [formGroup]="signInForm"
      (ngSubmit)="ChangePassword()"
    >
      <div class="flex flex-column w-100 py-2">
        <label class="block mb-2" for="username">{{
          "AUTH.PASSWORD" | translate
        }}</label>
        <input
          id="password"
          formControlName="password"
          type="text"
          class="w-full"
          pInputText
          placeholder="{{ 'AUTH.PASSWORD' | translate }}"
          required
        />
      </div>
      <div class="flex flex-column w-100 py-2">
        <label class="block mb-2" for="username">{{
          "AUTH.REPEAT-PASSWORD" | translate
        }}</label>
        <input
          id="repeat_password"
          formControlName="repeat_password"
          type="text"
          class="w-full"
          pInputText
          placeholder="{{ 'AUTH.PASSWORD' | translate }}"
          required
        />
      </div>
    </form>
    <div class="flex flex-1 mt-3">
      <button
        pButton
        label="{{ 'AUTH.SEND' | translate }}"
        class="flex flex-1"
        [disabled]="!signInForm.valid"
        (click)="dataForm.ngSubmit.emit()"
      ></button>
    </div>
  </div>
</div>
